"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import clsx from 'clsx';
import { EditorTagBadgeIcon } from './index.mjs';
import { SvgIconType } from '../../../SvgIcon/svg-icon-type.mjs';
import { intersperse } from '../../../../helpers/intersperse.mjs';
import { withSlotScopeClasses } from '../../../../helpers/scoped-slots.mjs';
import { Fragment as Fragment$1 } from 'react';
import { tv } from 'tailwind-variants';

const nestedBadgeValueRecipe = tv({
  slots: withSlotScopeClasses("nested-badge-value", {
    root: "flex flex-row flex-nowrap items-center truncate [&_svg]:inline-block [&_svg]:align-middle",
    segment: "text-xs leading-4",
    "visible-segment": "shrink-0 grow-0",
    "truncated-segment": "inline-block truncate",
    chunk: "whitespace-nowrap text-xs leading-4 truncate"
  })
});
function NestedBadgeValue({ nameChunks, fullName }) {
  if (nameChunks.length === 0) {
    return /* @__PURE__ */ jsx(Fragment, { children: "Error: undefined" });
  }
  const styles = nestedBadgeValueRecipe();
  const nameElements = nameChunks.map((chunk, idx) => /* @__PURE__ */ jsx("span", { className: styles.chunk(), children: chunk }, idx + chunk));
  if (nameElements.length === 1) {
    return /* @__PURE__ */ jsx("span", { className: styles.root(), children: nameElements[0] });
  }
  if (nameElements.length <= 2) {
    return /* @__PURE__ */ jsx("span", { className: styles.root(), children: intersperse(nameElements, /* @__PURE__ */ jsx(ValueNestingIcon, {})).map((segment, i) => /* @__PURE__ */ jsx(Fragment$1, { children: segment }, i)) });
  }
  const { 0: first, [nameChunks.length - 1]: last, ...rest } = nameElements;
  const middle = Object.values(rest);
  return /* @__PURE__ */ jsxs("span", { className: styles.root(), title: fullName, children: [
    /* @__PURE__ */ jsx("span", { className: clsx(styles.segment(), styles["visible-segment"]()), children: first }),
    /* @__PURE__ */ jsx("span", { className: clsx(styles.segment(), styles["truncated-segment"]()), children: middle.map((segment, idx) => [/* @__PURE__ */ jsx(ValueNestingIcon, {}, idx), segment]).flat().map((segment, i) => /* @__PURE__ */ jsx(Fragment$1, { children: segment }, i)) }),
    /* @__PURE__ */ jsxs("span", { className: clsx(styles.segment(), styles["visible-segment"]()), children: [
      /* @__PURE__ */ jsx(ValueNestingIcon, {}),
      last
    ] })
  ] });
}
function ValueNestingIcon() {
  return /* @__PURE__ */ jsx(EditorTagBadgeIcon, { type: SvgIconType.ChevronRight, className: "mb-0.5" });
}

export { NestedBadgeValue, ValueNestingIcon };
